/**
 * What to tell the scorer about the queue when they are *not* on the scoring screen.
 *
 * The pill only exists on the pad, so a scorer who has stepped back to the match list — or
 * whose phone was handed to somebody else — could otherwise have balls waiting and no way to
 * know. Pure so the wording and the priorities are testable without a browser.
 *
 * Says nothing unless the scorer has to *do* something. A queue that is draining, or waiting for
 * signal, needs nothing from them and is not announced: text telling a scorer their balls are
 * safe is text they have to read and then ignore, at the moment they are busy.
 */
import type { DrainSummary } from "@sportsos/sync";

export interface QueueNotice {
  readonly tone: "bad";
  readonly text: string;
}

const balls = (n: number): string => `${n} ${n === 1 ? "ball" : "balls"}`;

export function queueNotice(summary: DrainSummary): QueueNotice | null {
  // A decision only a person can make comes first.
  if (summary.foreign > 0) {
    return {
      tone: "bad",
      text: `${balls(summary.foreign)} on this phone ${summary.foreign === 1 ? "was" : "were"} scored by another account, so ${summary.foreign === 1 ? "it is" : "they are"} not being sent. Sign back in as that account to send ${summary.foreign === 1 ? "it" : "them"}.`,
    };
  }
  if (summary.needsSignIn) {
    return { tone: "bad", text: "Sign in to send the balls waiting on this phone." };
  }
  return null;
}
